import { defineStore } from 'pinia'

export const usePopupStore = defineStore('popup', {
  state: () => {
    return {
      rewards: [],
      documentType: '',
      frameUrl: '',
      frameTitle: '',
      frameCloseFn: undefined,
      gameFrameUrl: '',
      gameFrameCloseFn: undefined,
      walletAccount: null,
      walletCloseFn: undefined,
      showReward: false,
      showFollow: false,
      showAgeVerifiction: false,
      showDocument: false,
      showGameFrame: false,
      showInAppFrame: false,
      showBindWallet: false,
      showTransactionPassword: false,
    }
  },
  actions: {
    set(key, value = true) {
      this[key] = value;
    },
    showRewards(rewards) {
      if(Array.isArray(rewards)) {
        this.rewards = rewards;
      } else {
        this.rewards = [{ type: "cash", amount: rewards }];
      }
      this.showReward = true;
    },
    openUrlInFrame(url, title = '', closeCallback) {
      this.frameUrl = url;
      this.frameTitle = title;
      this.frameCloseFn = closeCallback || undefined;
      this.showInAppFrame = true;
    },
    closeUrlInFrame() {
      this.frameUrl = '';
      this.frameTitle = '';
       if (this.frameCloseFn) {
        this.frameCloseFn()
      }
      this.frameCloseFn = undefined;
      this.showInAppFrame = false;
    },
    openGameFrame(url, closeCallback) {
      this.gameFrameUrl = url;
      this.gameFrameCloseFn = closeCallback || undefined;
      this.showGameFrame = true;
    },
    closeGameFrame() {
      this.gameFrameUrl = '';
      if (this.gameFrameCloseFn) {
        this.gameFrameCloseFn()
      }
      this.gameFrameCloseFn = undefined;
      this.showGameFrame = false;
    },
    openBindWallet(account, closeCallback) {
      this.walletAccount = account || null;
      this.walletCloseFn = closeCallback || undefined;
      this.showBindWallet = true;
    },
    closeBindWallet() {
      this.walletAccount = null;
      if (this.walletCloseFn) {
        this.walletCloseFn()
      }
      this.walletCloseFn = undefined;
      this.showBindWallet = false;
    },
    openDocument(type) {
      this.showDocument = true;
      this.documentType = type;
    },
  }
})
